import 'core-js/es/map';
import 'core-js/es/set';
import 'promise-polyfill/src/polyfill';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
import axios from 'axios';
import React, { createContext, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { store } from './store';
import { AppLink } from './containers/appLink';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/reset.css';
import { ConfigProvider } from 'antd';
import * as Sentry from '@sentry/react';

if (process.env.REACT_SENTRY_DSN || process.env.MIX_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_SENTRY_DSN || process.env.MIX_SENTRY_DSN,
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        integrations: [new Sentry.Replay()],
    });
} else {
    console.log('Sentry not initialized');
}

library.add(fas);

axios.defaults.baseURL = process.env.REACT_APP_URL || window.location.origin;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

Object.equals = function (firstObj, secondObject) {
    if (
        ('object' != typeof firstObj && 'object' != typeof secondObject) ||
        null === firstObj ||
        null === secondObject
    )
        return firstObj == secondObject;
    //оба из простых - сравнение простых значений.
    else if ('object' != typeof firstObj || 'object' != typeof secondObject)
        return false; //сравнивается простое значение с объектом - всегда не равны
    //в этой точке только если сравниваем именно объекты (оба)

    //отдельно для дат
    if (firstObj instanceof Date && secondObject instanceof Date)
        return firstObj.getTime() == secondObject.getTime();
    //исключение для дат. сравним их по микросекундам
    else if (firstObj instanceof Date && secondObject instanceof Date)
        return false; //Если дата сравнивается с чем-то ещё -то всегда выдать несоответствие

    //далее сравниваем нормальные объекты
    let keysFirstObj = Object.keys(firstObj),
        keysSecondObject = Object.keys(secondObject);

    if (keysFirstObj.length != keysSecondObject.length) {
        return false;
    }
    return !keysFirstObj.filter(function (key) {
        if (typeof firstObj[key] == 'object' || Array.isArray(firstObj[key])) {
            return !Object.equals(firstObj[key], secondObject[key]);
        } else {
            return firstObj[key] !== secondObject[key];
        }
    }).length;
};

function useSetting(name, initialState) {
    const [state, setState] = useState({
        settings: initialState,
        snapshot: initialState,
    });
    return { [name]: { ...state, setSettings: setState } };
}
function useColumns(name) {
    const [state, setState] = useState(false);
    return { [name]: { showColumns: state, setShowColumns: setState } };
}
export const Context = createContext({
    isSticky: [false, () => null],
    cart: null,
    contentWrapper: null,
    contentContainer: null,
    settings: {},
    showColumns: {},
});

const ContextWrapper = ({ children }) => {
    const sticky = useState(false);
    const cart = useRef(null);
    const contentWrapper = useRef(null);
    const contentContainer = useRef(null);
    const lendingSections = useSetting(
        'lendingSections',
        window.lend_setting?.mainPage
    );
    const navbar = useSetting('navbar', window.lend_setting?.navbar);
    const activeTypes = useSetting('activeTypes', null);
    const showColumns = useColumns('showColumns');

    return (
        <Context.Provider
            value={{
                isSticky: sticky,
                cart,
                contentWrapper,
                contentContainer,
                settings: {
                    ...lendingSections,
                    ...activeTypes,
                    ...navbar,
                },
                showColumns,
            }}
        >
            {children}
        </Context.Provider>
    );
};

const ThemeProvider = ({ children }) => {
    const [style, setStyle] = useState(null);
    function getProperty(name) {
        return style?.getPropertyValue(name) || '';
    }
    useEffect(() => {
        document.addEventListener('DOMContentLoaded', () => {
            const style = getComputedStyle(document.body);
            setStyle(style);
        });
    }, []);
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: getProperty('--color-primary'),
                    sizeUnit: 3,
                    sizeStep: 3,
                    colorSplit: '#E3EAF4',
                },
                components: {
                    Typography: {
                        colorLink: getProperty('--color-primary'),
                        colorLinkHover: getProperty('--color-primary'),
                    },
                    Modal: {
                        padding: 30,
                        paddingContentHorizontalLG: 30,
                        paddingLG: 30,
                        paddingMD: 30,
                        paddingXS: 15,
                    },
                    Breadcrumb: {
                        // colorBgTextHover: '#000000',
                        // colorText: '#fff',
                    },
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};
ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ContextWrapper>
                <ThemeProvider>
                    <AppLink />
                </ThemeProvider>
            </ContextWrapper>
        </BrowserRouter>
    </Provider>,
    document.getElementById('app')
);
